// extracted by mini-css-extract-plugin
module.exports = {"editorContainer":"style_editorContainer__oU9hh","hoverClass":"style_hoverClass__bCF2_","edit":"style_edit__6joTu","editor":"style_editor__OF1RL"};